import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles, createStyles } from '@material-ui/core';
import { OutageLookupResponse } from '../../../../../__generated__/pge-types';
import OutageLocationLookup from '../OutageLocationLookup';
import {
  NotificationRequestAccountParams,
  OutageDetailInfo,
} from '../../../OutageCenterPage';

const useStyles = makeStyles(() =>
  createStyles({
    bottomSheet: {
      padding: '20px 20px 0',
      paddingTop: 0,
    },
  }),
);

type Props = {
  open: boolean;
  premiseInfo?: string;
  accontNumber: string;
  name: string;
  primaryContactNumber: string;
  onClose: () => void;
  isOtherLocation: boolean;
  setShowReconnectPopup?: () => void;
  onPrevious: (hNumber?: string, showResetInfo?: boolean) => void;
  setHouseNumber?: (houseNumber: string) => void;
  reportInfo: (lookupinfo: OutageDetailInfo) => void;
  outageLookUpResult: (
    data?: OutageLookupResponse,
    isMultiPremise?: boolean,
    showSuccess?: boolean,
  ) => void;
  setLoggedInUserNotificationRequestAccountParams: React.Dispatch<
    React.SetStateAction<NotificationRequestAccountParams>
  >;
  reportOutageForLoggedIn: () => void;
};

const OutageReportPopupMobApp: FC<Props> = ({
  onClose,
  premiseInfo,
  accontNumber,
  name,
  isOtherLocation,
  setShowReconnectPopup,
  setHouseNumber,
  onPrevious,
  reportInfo,
  primaryContactNumber,
  outageLookUpResult,
  setLoggedInUserNotificationRequestAccountParams,
  reportOutageForLoggedIn,
}: Props) => {
  const classes = useStyles();
  return (
    <Box component="div" className={classes.bottomSheet}>
      <OutageLocationLookup
        setLoggedInUserNotificationRequestAccountParams={
          setLoggedInUserNotificationRequestAccountParams
        }
        onClose={onClose}
        premiseInfo={premiseInfo}
        reportInfo={reportInfo}
        name={name}
        isOtherLocation={isOtherLocation}
        setShowReconnectPopup={setShowReconnectPopup}
        setHouseNumber={setHouseNumber}
        primaryContactNumber={primaryContactNumber}
        accontNumber={accontNumber}
        outageLookUpResult={outageLookUpResult}
        onPrevious={onPrevious}
        reportOutageForLoggedIn={reportOutageForLoggedIn}
      />
    </Box>
  );
};

export default OutageReportPopupMobApp;
